import { render, staticRenderFns } from "./piediagramm.vue?vue&type=template&id=68e24b83&scoped=true&"
import script from "./piediagramm.vue?vue&type=script&lang=js&"
export * from "./piediagramm.vue?vue&type=script&lang=js&"
import style0 from "./piediagramm.vue?vue&type=style&index=0&id=68e24b83&scoped=true&lang=css&"
import style1 from "./piediagramm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e24b83",
  null
  
)

export default component.exports